import { AgentModel } from '@/lib/models/agent.model';
import { DatasourceModel } from '@/lib/models/datasource.model';
import { PublicServiceMeta } from '@/lib/models/public-service';
import { ThreadSettingsModel } from '@/lib/models/thread/thread-settings.model';
import { HomeModel } from '@/lib/models/user-settings/home.model';
import { PreferencesModel } from '@/lib/models/user-settings/preferences.model';
import { ThreadHistoryModel } from '@/lib/models/user-settings/thread-history.model';
import { TileModel } from '@/lib/models/user-settings/tile.model';
import { PrivateModelSettings } from '@/lib/services/model.service';
import { createContext } from 'react';

export interface IUserSettings {
  threadSettings: ThreadSettingsModel;

  datasources: DatasourceModel[];
  publicSearchAvailable: boolean;
  togglePublicSearch: (enabled: boolean) => void;
  toggleDatasource: (datasourceId: string | string[], enabled: boolean) => void;

  // Agent settings
  agents: AgentModel[];
  setAgentId: (agentId: string) => void;
  defaultAgent: AgentModel;

  // Private model settings
  privateModelSettings: PrivateModelSettings;
  setPrivateModelId: (privateModelId: string) => void;

  // Preferences
  preferences: PreferencesModel;
  patchPreferences: (data: Partial<PreferencesModel>) => void;

  // Public services
  publicServices: PublicServiceMeta[];

  // Home tiles
  home: HomeModel;
  toggleFavorite: (tile: TileModel, favorite?: boolean) => void;
  moveFavorite: (tileId: string, targetTileId: string) => void;
  toggleRecent: (tile: TileModel, addRecent?: boolean) => void;

  // Thread history (consumed by ThreadHistoryProvider)
  threadHistory: ThreadHistoryModel[];
  updateThreadHistory: (
    updater: (prev: ThreadHistoryModel[]) => ThreadHistoryModel[]
  ) => void;

  isLoading: boolean;
}

export const UserSettingsContext = createContext<IUserSettings>({
  threadSettings: new ThreadSettingsModel(),

  datasources: [],
  publicSearchAvailable: false,
  togglePublicSearch: () => null,
  toggleDatasource: () => null,

  // Agent settings
  agents: [],
  setAgentId: () => null,
  defaultAgent: new AgentModel(),

  // Private model settings
  privateModelSettings: {
    defaultPrivateModelId: '',
    availablePrivateModels: [],
  },
  setPrivateModelId: () => null,

  publicServices: [],

  preferences: new PreferencesModel(),
  patchPreferences: () => null,

  home: new HomeModel(),
  toggleFavorite: () => null,
  moveFavorite: () => null,
  toggleRecent: () => null,

  threadHistory: [],
  updateThreadHistory: () => null,

  isLoading: false,
});
